import {Box} from '@mui/material';

interface PaymentMethodLogoProps {
  src: string;
  alt: string;
}
const PaymentMethodLogo: React.FC<PaymentMethodLogoProps> = ({src, alt}) => {
  return (
    <Box
      component={'img'}
      src={src}
      alt={alt}
      sx={{
        maxWidth: {xs: '30px', md: '45px'},
        maxHeight: {xs: '30px', md: '45px'},
        justifyContent: 'center',
        alignSelf: 'center',
        objectFit: 'cover'
      }}
    />
  );
};

export default PaymentMethodLogo;
